import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type { BaseApiResponse } from "../../../types/api.ts"

const PATH = "/user/project-list-settings/"

export interface ProjectListSettings {
  project_due_soon_days: number
  project_closing_soon_days: number
  project_stale_days: number
  project_attention_late: boolean
  project_attention_unscheduled: boolean
  project_attention_unassigned: boolean
  project_attention_stale: boolean
  project_attention_over_budget: boolean
}

export const getProjectListSettings = (): Promise<
  ApiResponse<ProjectListSettings>
> => request.api.get(PATH)

// The PATCH answer is enveloped (see automatic-project-creation-settings).
export const updateProjectListSettings = (
  payload: Partial<ProjectListSettings>
): Promise<ApiResponse<BaseApiResponse<ProjectListSettings>>> =>
  request.api.patch(PATH, payload)
